<template>
  <div class="enterprise-detail">
    <el-card class="enterprise-info mb15" v-loading="loading">
      <div slot="header" class="clearfix" style="line-height: 28px">
        <span class="fl">战略合伙人信息</span>
        <div class="fr"><el-button size="mini" type="link" @click="$router.go(-1)">返回</el-button></div>
      </div>
      <el-form :inline="true" size="mini" :label-position="'right'" label-width="110px">
        <el-form-item label="战略合伙人名称">
          <div class="w200">{{ form.name }}</div>
        </el-form-item>
        <el-form-item label="负责人姓名">
          <div class="w200">{{ form.developerName }}</div>
        </el-form-item>
        <el-form-item label="负责人电话">
          <div class="w200">{{ form.developerPhone }}</div>
        </el-form-item>
        <el-form-item label="加盟日期">
          <div class="w200">{{ form.createTime }}</div>
        </el-form-item>
        <el-form-item label="状态">
          <div class="w200">{{ form.state === 0 ? '有效' : (form.state === 1 ? '无效' : '') }}</div>
        </el-form-item>
        <el-form-item label="二级合伙人数量">
          <div class="w200">{{ form.partnerCount }}</div>
        </el-form-item>
        <el-form-item label="会员总数">
          <div class="w200">{{ form.panelCount }}</div>
        </el-form-item>
        <el-form-item label="关注会员总数">
          <div class="w200">{{ form.panelFocusCount }}</div>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <div class="enterprise-tab">
        <el-tabs v-model="acTabName" @tab-click="e => handleClick(e.name)">
          <el-tab-pane label="合伙人信息" :name="'0'"/>
          <el-tab-pane label="会员信息" :name="'1'"/>
        </el-tabs>
        <enterprise-partner ref="enterprisePartner" v-show="acTabName === '0'"/>
        <enterprise-member ref="enterpriseMember" v-show="acTabName === '1'"/>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { managerEnterprise as getDetail, getEnterprisePartnerList as getPartner, getEnterpriseMemberList as getMember} from 'api/request'
  import enterprisePartner from "./components/enterprisePartner"
  import enterpriseMember from "./components/enterpriseMember"
  export default {
    name: 'EnterpriseDetail',
    components: {
      enterprisePartner,
      enterpriseMember
    },
    data() {
      return {
        loading: false,
        enterpriseId: this.$route.query.id,
        form: {},
        acTabName: '0',
      }
    },
    mounted() {
      this.getDetail()
      this.handleClick('0')
    },
    methods: {
      async getDetail() {
        this.loading = true
        const res = await getDetail({ id: this.enterpriseId })
        if (res) {
          this.form = res
        }
        this.loading = false
      },
      handleClick(val) {
        this.acTabName = val
        this.$nextTick(() => {
          if (val === '0') {
            this.$refs.enterprisePartner.initData(this.enterpriseId)
          }
          if (val === '1') {
            this.$refs.enterpriseMember.initData(this.enterpriseId)
          }
        })
      },
      lookPartner(row) {}
    }
  }
</script>

<style scoped lang="scss">
  .enterprise-detail{
    /deep/.el-card__header{
      padding: 5px 20px;
    }
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .mb15{
      margin-bottom: 15px;
    }
    .enterprise-info{
      .el-form{
        .el-form-item{
          margin-bottom: 0;
        }
      }
    }
    .w200{
      width: 200px;
    }
  }
</style>
